var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['standard-navigation', {
      'standard-navigation-custom--external-header': _vm.externalHeadersVisible,
      'standard-navigation-custom--visible': _vm.isStandardMenuOpen,
      'standard-navigation-custom--hidden': !_vm.isStandardMenuOpen
    }],
    attrs: {
      "id": "standard-navigation"
    }
  }, [_c('button', {
    class: ['standard-navigation__mobile-arrow', {
      'standard-navigation__mobile-arrow--open': _vm.isStandardMenuOpen,
      'standard-navigation__mobile-arrow--close': !_vm.isStandardMenuOpen
    }],
    attrs: {
      "aria-label": _vm.isStandardMenuOpen ? 'Open' : 'Close'
    },
    on: {
      "click": _vm.hideShowNavigation
    }
  }, [_c('img', {
    attrs: {
      "src": "".concat(_vm.assetsPath, "/svg/apparelNavigation/icon-arrow-solid.svg"),
      "alt": "arrow icon"
    }
  })]), _c(_vm.itemsWrapperElement, {
    tag: "component",
    staticClass: "standard-navigation__item-wrapper",
    attrs: {
      "aria-labelledby": "standard-navigation-".concat(_vm.uuid)
    },
    on: {
      "!keydown": function keydown($event) {
        return _vm.onKeyDown.apply(null, arguments);
      }
    }
  }, _vm._l(_vm.items, function (item, index) {
    return _c('standard-navigation-item', {
      key: item.id,
      ref: "standard-navigation-item-".concat(index),
      refInFor: true,
      attrs: {
        "item": item,
        "items-element": _vm.itemsElement,
        "items-wrapper-element": _vm.itemsWrapperElement,
        "content-element": _vm.contentElement,
        "use-bullets": _vm.useBullets,
        "leaf-icon-content": _vm.leafIconContent,
        "closed-group-icon-content": _vm.closedGroupIconContent,
        "open-group-icon-content": _vm.openGroupIconContent,
        "enable-tab-index": index === 0,
        "multiple-same-level-nodes-opened": _vm.multipleSameLevelNodesOpened,
        "active-item-id": _vm.activeItemId,
        "focused-tree-item": _vm.focusedTreeItem,
        "update-expanded-flag-on-navigation": _vm.updateExpandedFlagOnNavigation,
        "activate-on-collapse": _vm.activateOnCollapse
      },
      on: {
        "tree-item-activated": _vm.onTreeItemActivatedRootHandler,
        "tree-item-received-focus": _vm.onTreeItemReceivedFocus,
        "tree-item-on-move-focus": function treeItemOnMoveFocus($event) {
          return _vm.onTreeItemKeyDown(item, $event);
        },
        "tree-item-on-focus-next-item": function treeItemOnFocusNextItem($event) {
          return _vm.onFocusNextItem(item);
        },
        "tree-item-on-focus-previous-item": function treeItemOnFocusPreviousItem($event) {
          return _vm.onFocusPreviousItem(item);
        },
        "tree-item-focus-parent": _vm.getFocus,
        "tree-view-item-collapse-siblings": _vm.onCollapseSiblings,
        "tree-item-expand-item": _vm.onTreeItemExpandItem,
        "tree-item-collapse-item": _vm.onTreeItemCollapseItem,
        "tree-item-go-to-first": _vm.onTreeItemGoToFirst,
        "tree-item-go-to-last": _vm.onTreeItemGoToLast
      }
    });
  }), 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }